module.exports = __webpack_public_path__ + "static/img/nodata.c33ca5c.png";


//////////////////
// WEBPACK FOOTER
// ./static/nodata.png
// module id = uxW8
// module chunks = 1